const FreelancerInvoiceStatusEnum=
{
    Created:'Created',
    Finalized:'Finalized',
    FileUploaded:'FileUploaded',
    InvoiceDismissed:'InvoiceDismissed',
    InvoiceApproved:'InvoiceApproved',
    Exported:'Exported',
    LinkedToExport:'LinkedToExport',
    ToBeSentToTipalti:'ToBeSentToTipalti',
    SentToTipalti:'SentToTipalti',
    DeletedAtTipalti:'DeletedAtTipalti',
    ErrorAtTipalti:'ErrorAtTipalti',
    Paid:'Paid',
    ManuallyPaidOutsideOfTipalti:'ManuallyPaidOutsideOfTipalti',
};

export default FreelancerInvoiceStatusEnum;